import { render, staticRenderFns } from "./cate06.vue?vue&type=template&id=08bd10f8"
import script from "./cate06.vue?vue&type=script&lang=js"
export * from "./cate06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports